import { render, staticRenderFns } from "./despachos.vue?vue&type=template&id=b8fb34dc&scoped=true&"
import script from "./despachos.vue?vue&type=script&lang=js&"
export * from "./despachos.vue?vue&type=script&lang=js&"
import style0 from "./despachos.vue?vue&type=style&index=0&id=b8fb34dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fb34dc",
  null
  
)

export default component.exports